import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import VehiclesTableContainer from '../../../modules/vehicles/components/VehiclesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import VehiclesExtraFilters from './VehiclesExtraFilters';

const Vehicles = ({ used }: { used?: boolean }) => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, searchEle, paginationEle } = useModuleTableHelpers({
    route: `admin/vehicles`,
    queryKey: 'vehicles',
    withSearch: true,
    breadcrumbTitle: t('links.vehicles'),
    withBreadcrumb: true,
    withPagination: true,
    notFilter: ["vehicle_make"],
    extraParams: {
      used: used ? 1 : 0
    },
    extraFilterRows: () => <VehiclesExtraFilters />,
  });

  const tableHeaders = [
    { label: t('chassis'), customClass: 'text-start' },
    { label: t('model') },
    { label: t('variant') },
    { label: t('price') },
    !used && { label: t('state') },
    !used && { label: t('last_dump_update') },
    { label: t('activate'), customClass: 'status_col' },
    // hasPermission(['vehicles.edit']) && { label: t('actions'), customClass: 'actions_col' }
    { label: t('actions'), customClass: 'actions_col' }
  ].filter(Boolean);

  if (apiDataLoading && !apiData) return <TableSkeleton columns={7} withoutButton />;

  return (
    <div className="vehicles-page-container">
      <ListHeader customClass='table_filters'>
        {searchEle}
      </ListHeader>
      <VehiclesTableContainer tableHeaders={tableHeaders} data={apiData} apiDataLoading={apiDataLoading} noDataMessage={t('no_vehicles_found')} lessColumns used={used} />
      {paginationEle}
    </div>
  );
};

export default Vehicles;
